import { Filter, IFilterOptions } from 'components/filter/component'
import { connect, MapStateToProps } from 'react-redux'
import { Dispatch } from 'redux'
import { createSelector } from 'reselect'
import { RootState } from 'stores'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { IDemographics } from 'types/IDemographics'
import { IFilter } from 'types/IFilter'
import { Publication } from 'types/publication'
import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

type Demographics = Age | Education | Gender | Publication

const getReaderAnswers = (state: RootState) => state.readerAnswers

const getUniqueValues: <U extends IDemographics>(
  property: keyof U
) => (acc: Demographics[], currentValue: U) => Demographics[] = property => (
  acc,
  currentValue
) => {
  if (!acc.includes((currentValue[property] as unknown) as string)) {
    acc.push((currentValue[property] as unknown) as string)
  }
  return acc
}

const getAvailableData = (property: keyof IDemographics) =>
  createSelector(
    getReaderAnswers,
    answers => answers.reduce(getUniqueValues(property), []) || []
  )

const mapStateToProps: MapStateToProps<
  IFilter & IFilterOptions,
  {},
  RootState
> = (state: RootState) => {
  return {
    ...state.filter,
    availableAges: getAvailableData('age')(state),
    availableEducation: getAvailableData('education')(state),
    availableGenders: getAvailableData('gender')(state),
    availablePublications: getAvailableData('publication')(state)
  }
}
const mapDispatchToProps = (
  dispatch: Dispatch<ActionType<typeof actions>>
) => ({
  handleAge: (selection?: string) =>
    dispatch(actions.updateAgeFilter(selection as Age)),
  handleEducation: (selection?: string) =>
    dispatch(actions.updateEducationFilter(selection as Education)),
  handleGender: (selection?: string) =>
    dispatch(actions.updateGenderFilter(selection as Gender)),
  handlePublication: (selection?: string) =>
    dispatch(actions.updatePublicationFilter(selection as Publication))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter)
